import * as firebase from 'firebase';
//const app = require('firebase');
import env from './env.json'

const config = {
  apiKey: "AIzaSyCtbqg9GPcFaCIyhinN71_XFkRosGY77Ro",
  databaseURL: "hometheory-c3dab.firebaseapp.com",
  projectId: "hometheory-c3dab",
  storageBucket: "hometheory-c3dab.appspot.com",
  messagingSenderId: "1086195604706",
  appId: "1:1086195604706:web:0442b744e1701fe16252bb",
  measurementId: "G-0F0H6RZSDG"
};

const devConfig = {
  apiKey: "",
  databaseURL: "",
  projectId: "",
  storageBucket: "",
  messagingSenderId: "",
  appId: "",
  measurementId: ""
};

var result = null
var chosen = config//devConfig
if (env.PRODUCTION) {
  chosen = config
}

if (!firebase.apps.length) {
  result = firebase.initializeApp(chosen)
} else {
  result = firebase.app();
}

export default result//!firebase.apps.length ? firebase.initializeApp(config) : firebase.app();

/*
const devConfig = {
  apiKey: process.env.REACT_APP_DEV_API_KEY,
  authDomain: process.env.REACT_APP_DEV_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DEV_DATABASE_URL,
  projectId: process.env.REACT_APP_DEV_PROJECT_ID,
  storageBucket: process.env.REACT_APP_DEV_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_DEV_MESSAGING_SENDER_ID,
};

const config =
  process.env.NODE_ENV === 'production' ? prodConfig : devConfig;
*/

/*<script>
  // Your web app's Firebase configuration
  var firebaseConfig = {
    apiKey: "",
    authDomain: "hometheory-c3dab.firebaseapp.com",
    databaseURL: "https://hometheory-c3dab.firebaseio.com",
    projectId: "hometheory-c3dab",
    storageBucket: "hometheory-c3dab.appspot.com",
    messagingSenderId: "1086195604706",
    appId: "1:1086195604706:web:0442b744e1701fe16252bb",
    measurementId: "G-0F0H6RZSDG"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();
</script>*/



// WEBPACK FOOTER //
// src/FirebaseConfig.js